import * as React from 'react';
import { orderBy } from 'lodash';

import { SeatStyle, SeatStyleCulture, Seat } from '../../classes/seat';
import { IAppSettingsModel } from '../../reducers/fetch-settings-reducer';

import { formatString } from '../../helpers/string-format';
import isMobile from '../../helpers/is-mobile';

interface ILegendProps {
    seatStyles: Array<SeatStyle>;
    seatStyleCultures: Array<SeatStyleCulture>;
    legendTitle: string;
    legendTitleAltText: string;
    selectedSeats: boolean;
    legendFlyOut: boolean;
    updateLegendFlyout: (updateFlyout: boolean) => void;
    isMobile: boolean;
}

interface ILegendState {
    firstTimeHidden: boolean; //used to keep track so we only close the legend once so if users want to use the legend on mobile, they can open it again
}

class Legend extends React.PureComponent<ILegendProps, ILegendState>{

    constructor(props) {
        super(props);
        this.state = { firstTimeHidden: false };
    }
    componentWillReceiveProps(nextProps: ILegendProps) {

        if (!this.state.firstTimeHidden && nextProps.isMobile && nextProps.selectedSeats) {
            if (this.props.legendFlyOut) {
                nextProps.updateLegendFlyout(false);
            }

            this.setState({ firstTimeHidden: true });
        }
    }

    render() {
        const arrowIcon = '<use xlink:href="#icon-arrow-down" />';
        const useTag = '<use xlink:href="#icon-close" />';

        const culturesWithDisplayName = this.props.seatStyleCultures.filter(culture => culture.displayName != null);

        const visibleStyles = orderBy(this.props.seatStyles.filter(style => { return culturesWithDisplayName.some(culture => culture.seatStyleId === style.id) }),
            (style) => {
                return culturesWithDisplayName.filter(cultur => cultur.seatStyleId == style.id)[0].legendOrder;
            });

        let legendFilters =
            orderBy(visibleStyles.filter(style => culturesWithDisplayName.filter(cultur => cultur.seatStyleId == style.id)[0].showOnCollapsedLegend),
                (style) => {
                    return culturesWithDisplayName.filter(cultur => cultur.seatStyleId == style.id)[0].legendOrder;
                }
            ).map(style => {
                return <div key={style.id} className="legend-default-icon" style={{ backgroundColor: style.svgDefaultFill }}></div>;
            });

        if (legendFilters.length > 3) {
            legendFilters = legendFilters.filter((value, index) => index < 3);
        }

        return (
            <div className={"legend-container" + (this.props.legendFlyOut ? " open" : "")}>
                {
                    !this.props.legendFlyOut ?
                        <div className="legend-trigger" onClick={(evt) => { this.props.updateLegendFlyout(true) }}>
                            <div className="legend-default-dots">
                                {
                                    legendFilters
                                }
                            </div>

                            <p>{this.props.legendTitle}</p>

                        </div>

                        : null
                }
                {
                    this.props.legendFlyOut ?

                        <div className="legend-modal">
                            <div className="legend-modal-inner">
                                <div className="legend-modal-header">
                                    <h2>{this.props.legendTitle}</h2>
                                    <svg className="legend-close-icon" dangerouslySetInnerHTML={{ __html: useTag }} onMouseDown={(evt) => { this.props.updateLegendFlyout(false) }} />

                                </div>
                                <div className="legend-wrapper" onMouseDown={(evt) => { this.props.updateLegendFlyout(true) }}>
                                    <div className="legend-default">
                                        <div className="legend-default-dots">
                                            {
                                                legendFilters
                                            }
                                        </div>
                                        <p>{this.props.legendTitle}</p>
                                    </div>

                                    <div className="legend-content">
                                        <ul className="legend-list">
                                            {visibleStyles.map(style => {
                                                return <li key={style.id} className="legend-list-item">
                                                    <svg width="30px" className="legend-list-item-icon" viewBox={style.seatStyleSvgPath != null && style.seatStyleSvgPath.length > 0
                                                        ? style.svgViewBox : "0 0 30 30"} aria-labelledby="selectedSeatStyleAltText">
                                                        <title id="selectedSeatStyleAltText">{formatString(this.props.legendTitleAltText, [culturesWithDisplayName.filter(culture => culture.seatStyleId == style.id)[0].displayName])}</title>
                                                        {style.seatStyleSvgPath != null && style.seatStyleSvgPath.length > 0 ?
                                                            <path d={style.seatStyleSvgPath} fill={style.svgDefaultFill} stroke={style.svgStrokeColor} strokeWidth={style.svgStrokeWidth}></path>
                                                            :
                                                            <circle r="15" cx="15" cy="15" fill={style.svgDefaultFill} stroke={style.svgStrokeColor} strokeWidth={style.svgDefaultFill != style.svgStrokeColor ? style.svgStrokeWidth : "0"}></circle>
                                                        }
                                                    </svg>
                                                    <span className="legend-list-item-name">{culturesWithDisplayName.filter(culture => culture.seatStyleId == style.id)[0].displayName}</span>
                                                </li>
                                            })}
                                        </ul>
                                    </div>
                                </div>

                            </div>
                        </div>
                        : null
                }


            </div>
        );
    }
}

export default Legend;